import useNetworkStatus from 'hooks/useNetworkStatus';
import React from 'react';
import { FaWifi, FaTimes } from 'react-icons/fa'; // Íconos para online y offline

/**
 * @component NetworkStatusIndicator
 * @description
 * Componente visual que muestra el estado actual de la conexión de red del usuario.
 * Utiliza el hook `useNetworkStatus` para detectar si el usuario está online u offline.
 *
 * Muestra un ícono verde (WiFi) cuando está conectado y un ícono rojo (X) cuando está desconectado.
 * El indicador aparece en la parte superior derecha de la pantalla y permanece visible.
 *
 * @returns {JSX.Element} Elemento visual con el estado de la conexión de red.
 */
const NetworkStatusIndicator = () => {
	const isOnline = useNetworkStatus(); // Saber si está online o offline

	return (
		<div style={statusStyles}>
			{isOnline ? (
				<FaWifi style={{ ...iconStyle, color: 'green' }} />
			) : (
				<FaTimes style={{ ...iconStyle, color: 'red' }} />
			)}
			<span style={{ ...statusText, color: isOnline ? 'green' : 'red' }}>
				{isOnline ? ' Online' : ' Offline'}
			</span>
		</div>
	);
};

export default NetworkStatusIndicator;

/**
 * Estilos aplicados al contenedor del estado de red.
 * Fijado en la esquina superior derecha.
 */
const statusStyles = {
	display: 'flex',
	alignItems: 'center',
	position: 'fixed',
	top: '20px',
	right: '20px',
	backgroundColor: '#f1f1f1',
	color: '#333',
	zIndex: 1000
};

/**
 * Estilos del texto que acompaña el ícono.
 */
const statusText = {
	marginLeft: '8px',
	fontSize: '1rem'
};

/**
 * Estilos aplicados al ícono (WiFi o X).
 */
const iconStyle = {
	fontSize: '1.5rem'
};